/**
 * Strip default param values khỏi URLSearchParams cho /approvals page.
 * → URL ngắn gọn, share dễ. Default values:
 *   - tab=tasks
 *   - view=table (cột)
 *   - filter=pending khi tab=tasks
 *   - filter=active khi tab=sent
 *
 * Mutates input in-place + returns it (for chaining).
 */
export function stripDefaultApprovalParams(params) {
  if (params.get('view') === 'table') params.delete('view');
  if (params.get('tab') === 'tasks') params.delete('tab');
  const tab = params.get('tab') || 'tasks';
  const filter = params.get('filter');
  if ((tab === 'tasks' && filter === 'pending') || (tab === 'sent' && filter === 'active')) {
    params.delete('filter');
  }
  return params;
}
